<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link
  href="https://fonts.googleapis.com/css2?family=Amaranth:ital,wght@0,400;0,700;1,400;1,700&family=Merriweather:ital,opsz,wght@0,18..144,300..900;1,18..144,300..900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Oswald:wght@200..700&display=swap"
  rel="stylesheet"
/>

<div
  class="f-editor-wrapper"
  [froalaEditor]="editorOptions"
  [formControl]="editor()"
  [class.f-text-editor-validation]="requiredAndInvalid || isCustomError"
></div>
@if(requiredAndInvalid) {
<p class="k-editor-validation-message k-editor-validation-message-position">{{ requiredErrorMessage() }}</p>
} @if(validation()?.message) {
<p class="k-editor-validation-message k-editor-validation-message-position">{{ validation()?.message }}</p>
}
<div class="fr-contextual-menu" #contextualMenu>
  <ng-content></ng-content>
</div>
